import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { ModalContainer } from "../../../../../../common/components/modal_container";
import { IrParaAction } from "./ir_para_action";

/**
 * TipoCadastroObraModal
 */

const TIPO_CADASTRO_CENTRO_CUSTO = 1;
const TIPO_CADASTRO_EMPREENDIMENTO = 2;

type Props = {
  open: boolean;
  onClose: () => void;
  onSelect: (porEmpreendimento: boolean, openNewTab: boolean) => void;
};

export const TipoCadastroObraModal = ({
  open,
  onClose,
  onSelect,
}: Props) => {
  const handleExecuteAction = (idAction: number, openNewTab: boolean) => {
    onSelect(idAction === TIPO_CADASTRO_EMPREENDIMENTO, openNewTab);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "26rem",
          },
        },
      }}>
      <DialogTitle>
        Nova Obra
      </DialogTitle>

      <DialogContent>
        <ModalContainer>
          <div className="grid grid-cols-2 gap-4 my-4">
            <IrParaAction
              id={TIPO_CADASTRO_CENTRO_CUSTO}
              icon="AccountBalanceOutlined"
              label="Cadastrar por Centro de Custo"
              onExecuteAction={handleExecuteAction}
            />

            <IrParaAction
              id={TIPO_CADASTRO_EMPREENDIMENTO}
              icon="ApartmentOutlined"
              label="Cadastrar por Empreendimento"
              onExecuteAction={handleExecuteAction}
            />
          </div>
        </ModalContainer>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex px-4 pb-2">
          <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
            <h1
              className="text-sm text-black dark:text-white"
              onClick={onClose}>
              Cancelar
            </h1>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}
